/* eslint-disable space-before-function-paren */
/* eslint-disable react/jsx-indent */
/* eslint-disable @typescript-eslint/indent */
import React from 'react'
import { useGetCurrentOwner } from '../../hooks/apolloHooks/useGetCurrentOwner'
import ErrorDisplay from '../elements/ErrorDisplay'
import Icon from '../elements/Icon'
import Link from '../elements/Link'

type Props = {}


export const ContactPage: React.FC<Props> = () => {
    const { owner, loading, error } = useGetCurrentOwner()

    if (loading) return (
        <div className="loading-page"><span className="loader-zoom"></span></div>
    )

    if (error) return (
        <ErrorDisplay errorContext="Fel vid laddning av kontaktuppgifter:" errorMessage={error?.message} />
    )

    return (
        <div className="Section ContactPage">
            <div className="Row Row--JustifyLeft">
                <div className="Row__Inner shadow-one white-pale-section contact-page">
                    <div className="contact-page__content">
                        <div className="left">
                            <div className="header">
                                <h1> {'Kontakta oss'} </h1>
                                <p>
                                    Har du frågor eller behöver hjälp?<br />
                                    Vår kundservice finns tillgänglig på telefon vardagar mellan 8-17, för att ge personlig support.
                                    När kundservice är stängt kan du bli kopplad till vår tekniska support.
                                </p>
                            </div>
                            <div className="contact-methods" id="kontakt">
                                <h5>Qstar kontaktuppgifter</h5>
                                <ul>
                                    <li>
                                        <Icon
                                            className="icon-contact"
                                            name="phone"
                                            primaryColor="black"
                                            secondaryColor="black"
                                        />
                                        <Link href={`tel:+46${owner?.contactInformation.phoneNumber.replace(/-/g, '').replace(/^0/, '')}`}>
                                            {owner?.contactInformation.phoneNumber.replace(/(\d{2})(\d{2})(\d{2})$/, '$1 $2 $3')}
                                        </Link>
                                    </li>
                                    <li>
                                        <Icon
                                            className="icon-contact"
                                            name="envelope-open"
                                            primaryColor="white"
                                            secondaryColor="black"
                                        />
                                        <Link href={`mailto:${owner?.contactInformation.emailAddress}`}>
                                            {owner?.contactInformation.emailAddress}
                                        </Link>
                                    </li>
                                    <li>
                                        <Icon
                                            className="icon-contact"
                                            name="map-marker-alt"
                                            primaryColor="black"
                                            secondaryColor="black"
                                        />
                                        <Link href={"https://maps.app.goo.gl/X4zEXYpuB6PgrApNA"}
                                            openNewTab={true}
                                        >
                                            {owner?.address.road}, {owner?.address.postalCode} {owner?.address.city}
                                        </Link>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        <div className="right">
                            <img
                                src="static/images/qstar-kundservice.jpg"
                                alt="Kontakta kundservice"
                            />
                        </div>

                        <div className="horizontal-divider"></div>
                        <div className="contact-page__address-update" id="adress">
                            <h5>Adressuppdatering</h5>
                            <p>
                                Din adress uppdateras automatiskt när ändring av folkbokföringsadress görs hos Skatteverket.
                                Skulle det vara något fel och adressen inte uppdaterats närmaste dagarna kontakta kundservice ovan.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactPage
